import type { IAccountBalances } from '~/interfaces/dto/wallet/response';
import type { AccountModals } from '~/interfaces/dto/general/modals';
import type { IUserInfoExtended } from '~/interfaces/dto/auth/response';
import type { CasinoBonus } from '~/interfaces/dto/bonus/response';
import type { IPromotionGenericWheelData } from '~/interfaces/dto/promotions/response';
import type {
  IRewardsBalanceResponse,
  IRewardsConfigResponse,
  IPeriod,
} from '~/interfaces/dto/rewards/response';
export interface AuthStoreInterface {
  userId: string | undefined;
  currentUser: Partial<IUserInfoExtended>;
  isLoggedIn: boolean;
  currentAccessToken: string | undefined;
  currentRefreshToken: string | undefined;
  displayAccountModal: boolean;
  welcomeOffer: boolean;
  displayBalances: boolean;
  userBalances: IAccountBalances;
  compliance: boolean;
  partialPostReg: boolean;
  accountModalPage: AccountModals | null;
  displayBonusBalance: boolean;
  activeBonus: Partial<CasinoBonus>;
  passwordResetMobileNumber: string | null;
  availableSpins: Partial<IPromotionGenericWheelData>[];
  rewardsBalance: Partial<IRewardsBalanceResponse>;
  rewardsConfig: Partial<IRewardsConfigResponse>;
  summaryYearConfig: Partial<IPeriod>[];
}

export interface LogoutOptions {
  redirect?: boolean;
  path?: string;
  reload?: boolean;
}

export enum EIdNumberType {
  None = 0,
  IdBooklet = 1,
  IdCard = 2,
  Passport = 3,
  DriversLicense = 4,
  BirthCertificate = 5,
  BirthCertificateUnabridged = 6,
  IdNumber = 7,
  MobileNumber = 8,
  OldDriversLicense = 9,
  VoterId = 10,
  OldVoterId = 11,
  SocialSecurityNumber = 12,
  TaxNumber = 13,
  AlienCard = 14,
  BankVerificationNumber = 15,
  CorporateAffairsNumber = 16,
  IdentitySlip = 17,
}

export type TIdNumberType = keyof typeof EIdNumberType;

export type TComplianceCheckType = 'sumsub' | 'cpb' | 'none';
